import { render, staticRenderFns } from "./TenantUserDetailScreen.vue?vue&type=template&id=dde00022&scoped=true&lang=pug"
import script from "./TenantUserDetailScreen.vue?vue&type=script&lang=ts"
export * from "./TenantUserDetailScreen.vue?vue&type=script&lang=ts"
import style0 from "./TenantUserDetailScreen.vue?vue&type=style&index=0&id=dde00022&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde00022",
  null
  
)

export default component.exports